import { buildApiConfig } from '../services/api/apiClient';
import { endPointEnums } from '../services/api/endpoints';

// Returns config for useAPI for order creation
export function getOrderApiConfig(details, deliveryEstimateHours, paymentType = 'WALLET') {
  if (!details) return null;
  const normalizeAddress = (addr) => {
    if (!addr) return {};
    if (typeof addr === 'string') return { label: addr };
    return addr;
  };

  return buildApiConfig(endPointEnums.CREATE_PARCEL, {
    pickupAddress: { ...normalizeAddress(details.origin) },
    deliveryAddress: { ...normalizeAddress(details.destination) },
    parcelType: details.parcelType,
    parcelWeight: details.parcelWeight,
    parcelVolume: details.parcelVolume || '',
    description: details.description || '',
    deliveryInstructions: details.deliveryInstructions || '',
    price: details.price,
    deliveryEstimate: deliveryEstimateHours,
    paymentType,
  });
}
